import { appConfig } from 'brand-config';

/**
 * Whether this brand allows deleting offer Supporting Documents (#34202). On for the mutual
 * brands, off for Branch. Read from the build-time brand config; deletion is additionally gated by
 * the `CanDeleteInternalDocuments` permission and the backend's offer/ prefix check, so this only
 * controls whether the delete action is offered at all. Mirrors isCollectPaymentLaterAllowed.
 */
export const isDeleteSupportingDocumentsAllowed = () => Boolean(appConfig?.featureFlags?.deleteSupportingDocuments);
